import NotifyBase from './base';
export default class NotifyStandard extends NotifyBase {
  init(){
    this.scope = 'data.notify';
    this.elementId = 'notify-wrap';
    super.init();
  }
}
